import { IAppState } from '../../common/state';

export function selectNewbuildingBrokerConsultantBannerButtonText(state: IAppState) {
  return state.featureToggle.newbuildingBrokerConsultantBannerButtonText ?? undefined;
}
